import prd_vBNrxygcjjdQ from '@/data/products/one-time/prd_vBNrxygcjjdQ'
import prd_4JY2zE5skUWg from '@/data/products/one-time/prd_4JY2zE5skUWg'
import type { UpsellTemplateSchema, UpsellTemplateStepConfig } from '../@types/upsell-types'
import type { OneTimeProduct } from '@/composables/useProducts'
import { mergeDeep } from '@/helpers/utils'

export default (schema: UpsellTemplateSchema<OneTimeProduct>): UpsellTemplateSchema<OneTimeProduct> =>
	mergeDeep(
		{ ...schema },
		{
			config: {
				steps: (): UpsellTemplateStepConfig[] => {
					return [
						{
							product: prd_vBNrxygcjjdQ.ident,
							discountPercent: 45,
							modals: {
								skip: ['UpsellSkipUnwrapModal', 'UpsellSkipAnimationModal'],
							},
						},
						{
							product: prd_4JY2zE5skUWg.ident,
							discountPercent: 60,
						},
					]
				},
			},
		},
	)
